export const SET_SELECTED_HISTORY = 'SET_SELECTED_HISTORY';
